import {
  Box,
  Container,
  Grid,
  Link,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import React from "react";
import { allIcons, allImages } from "../../../assets";

const MainView = styled(Box)(({ theme }) => ({
  position: "relative",
  height: "100vh",
  backgroundColor: "#000000",
  [theme.breakpoints.down("md")]: {
    height: "auto",
  },

  "& .lpl_viewcon": {
    height: "inherit",
    position: "relative",
    height: "100vh",
    color: "#ffffff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    zIndex: 999,
    [theme.breakpoints.down("md")]: {
      height: "auto",
      padding: "2rem 16px",
    },
  },

  "& .link_btn_img": {
    width: "25%",
    [theme.breakpoints.down("sm")]: {
      width: "30%",
    },
  },

  "& .lpl_text_pr": {
    fontWeight: 600,
    fontSize: "4rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
    },
  },
  "& .lpl_text_sr": {
    fontWeight: 300,
    maxWidth: "600px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
    },
  },
}));

function Banner() {
  return (
    <MainView>
      <Container maxWidth={"lg"} className="lpl_viewcon">
        <Grid container spacing={2} flexWrap={"wrap-reverse"}>
          <Grid item xs={12} md={8}>
            <Typography variant="h1" className="lpl_text_pr">
              You can download the app{" "}
            </Typography>

            <Typography mt={2.5} variant={"h6"} className={"lpl_text_sr"}>
              "Experience seamless salon and spa management with our
              user-friendly mobile app.
            </Typography>
            <Typography mt={1} variant={"h6"} className={"lpl_text_sr"}>
              Effortlessly book appointments online and streamline your
              operations for enhanced client satisfaction."
            </Typography>
            <Typography mt={3} variant="h6" fontSize={"1rem"}>
              DOWNLOAD OUR APP
            </Typography>
            <Stack
              direction={"row" }
              alignItems={"center"}
              gap={2}
              my={2}
            >
              {/* <AppStoreBtn /> */}
              <Link
                href={"/"}
                target="_blank"
                style={{ display: "contents", cursor: "pointer" }}
              >
                <img
                  src={allImages.appStoreBtn}
                  width={"25%"}
                  className="link_btn_img"
                />
              </Link>
              <Link
                href={"/"}
                target="_blank"
                style={{ display: "contents", cursor: "pointer" }}
              >
                <img
                  src={allImages.playStoreBtn}
                  width={"25%"}
                  className="link_btn_img"
                />
              </Link>
            </Stack>
          </Grid>
          <Grid item xs={12} md={4}>
            <img src={allImages.landingMobileMain} width={"100%"} />
          </Grid>
        </Grid>
      </Container>
    </MainView>
  );
}

export default Banner;
